import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar.jsx";
import Footer from "../components/Footer.jsx";

const WebsiteLayout = () => {
    return (
        <div className="min-h-screen flex flex-col">
            {/* Common Navbar */}
            <Navbar />

            {/* Page Content */}
            <main className="flex-1 pt-16">
                <Outlet />
            </main>

            {/* Common Footer */}
            <Footer />
        </div>
    );
};

export default WebsiteLayout;
